import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3820fba0")

_pushScopeId("data-v-3820fba0")
const _hoisted_1 = {
  id: "startOfSearchCompany",
  class: "page-section flex flex--width flex--v flex--valign-c flex--gap-50"
}
const _hoisted_2 = { class: "flex flex--v flex--valign-c flex--gap-50" }
const _hoisted_3 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_4 = { class: "text text--primary-gradient text--bold text--size-30 text--center" }
const _hoisted_5 = { class: "text text--secondary-gradient text--medium text--size-24 text--less-gap text--center" }
const _hoisted_6 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_7 = { class: "flex flex--v flex--valign-c flex--gap-15" }
const _hoisted_8 = { class: "flex flex--v flex--width flex--valign-s flex--gap-15" }
const _hoisted_9 = { class: "flex flex--v flex--width flex--valign-s flex--gap-15" }
const _hoisted_10 = { class: "flex flex--v flex--valign-c flex--gap-15" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Plane = _resolveComponent("Plane")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('dashboard.title'),
    gap: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$trans("dashboard.greetings-title")), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$trans("dashboard.greetings-subtitle")), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", {
                class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--center",
                innerHTML: _ctx.$trans('dashboard.greetings-1')
              }, null, 8, ["innerHTML"]),
              _createVNode("span", {
                class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--center",
                innerHTML: _ctx.$trans('dashboard.greetings-2')
              }, null, 8, ["innerHTML"])
            ]),
            _createVNode(_component_Plane, { rounded: true }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", {
                    class: "text text--primary-b text--bold text--size-24 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-3')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-4')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-5')
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Plane, { rounded: true }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", {
                    class: "text text--primary-b text--bold text--size-24 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-6')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-7')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-8')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-9')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-10')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-11')
                  }, null, 8, ["innerHTML"]),
                  _createVNode("span", {
                    class: "text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left",
                    innerHTML: _ctx.$trans('dashboard.greetings-12')
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", {
                class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--center",
                innerHTML: _ctx.$trans('dashboard.greetings-13')
              }, null, 8, ["innerHTML"]),
              _createVNode("span", {
                class: "text text--accent-gray-b text--medium text--size-20 text--height-27 text--center",
                innerHTML: _ctx.$trans('dashboard.greetings-14')
              }, null, 8, ["innerHTML"])
            ])
          ]),
          _createVNode(_component_GenericButton, {
            title: _ctx.$trans('navigation.nav_acp_companies'),
            onClick: _ctx.clickCompanies
          }, null, 8, ["title", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})